import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ISO3LanguageCode, ZitadelUser } from "@src/types/user-management";

export interface PatchUpdateUsersResult {
  success: boolean;
  data?: ZitadelUser;
  error?: string;
}

export const patchUserLanguageUseCase = async (
  id: string,
  language: ISO3LanguageCode,
): Promise<PatchUpdateUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchUserLanguage(
      namespace,
      id,
      language,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update user").message,
    };
  }
};
